import { bindPrototypeMethodsToSelf } from '@wix/panorama-common/utils';
export class PanoramaErrorMonitorImpl {
  constructor(baseClient, options) {
    this.baseClient = baseClient;
    this.options = options;
    bindPrototypeMethodsToSelf(this);
  }
  reportError(error, data) {
    this.baseClient.reportError(error, data, this.options);
  }
  addBreadcrumb(breadcrumb) {
    this.baseClient.addBreadcrumb(breadcrumb);
  }
}
//# sourceMappingURL=panorama-error-monitor.js.map